import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusyIndicatorComponent } from './busy-indicator/busy-indicator.component';
import { ProgressBusyComponent } from './progress-busy/progress-busy.component';
import { SearchInputComponent } from './search-input/search-input.component';
import { BackButtonComponent } from './back-button/back-button.component';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { TimezoneService } from './time-zone/time-zone.service';

@NgModule({
    imports: [
        CommonModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatIconModule           
    ],
    declarations: [
        BusyIndicatorComponent,
        ProgressBusyComponent,
        SearchInputComponent,
        BackButtonComponent
   ],
    exports: [
        BusyIndicatorComponent,
        ProgressBusyComponent,
        SearchInputComponent,
        BackButtonComponent
    ],
    providers: [
        TimezoneService
    ]
})
export class CoreModule {}